// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"95b8a20a","631":"79229494"}[chunkId] + ".chunk.js";
};